const DESTINATION_KEY = 'ibk:auth-destination';
const ORIGIN_KEY = 'ibk:session-from-bpo';
export function setSessionFromBpo() {
    sessionStorage.setItem(ORIGIN_KEY, 'true');
}
export function isSessionFromBpo() {
    return sessionStorage.getItem(ORIGIN_KEY) === 'true';
}
export function clearSessionFromBpo() {
    sessionStorage.removeItem(ORIGIN_KEY);
}
export function setBpoLoginDestination() {
    sessionStorage.setItem(DESTINATION_KEY, '/bpo/clientes');
}
export function getLoginDestination() {
    return sessionStorage.getItem(DESTINATION_KEY) === '/bpo/clientes' ? '/bpo/clientes' : '/home';
}
export function clearLoginDestination() {
    sessionStorage.removeItem(DESTINATION_KEY);
}
